import { createAction } from 'redux-act';

export const enqueueSnackbar = createAction('Add notification to display');

export const closeSnackbar = createAction('Close notification');

export const removeSnackbar = createAction('Remove all notifications');
